// extracted by mini-css-extract-plugin
export default {"hour":"oT8KPAArjj","hour_current":"YgEkbyOrcz"};